import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import RIOSelect from '@rio-cloud/rio-uikit/Select';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { Controller } from 'react-hook-form';

import type { FormFieldProps } from './types';

const FormFieldSelect = ({ placeholder, name, options, required, error, label, control }: FormFieldProps) => {
    const setLabel = required ? (
        <div className='InputText__madatoryLabel'>
            <OverlayTrigger
                placement='top-start'
                overlay={
                    <Tooltip>
                        <p>Mandatory field</p>
                    </Tooltip>
                }
            >
                <label className='InputText__label' htmlFor={name}>
                    {label}
                </label>
            </OverlayTrigger>
            <span className='InputText__mandatoryIcon'>*</span>
        </div>
    ) : (
        <label className='InputText__label' htmlFor={name}>
            {label}
        </label>
    );

    return (
        <div className={`form-group mb-0 ${error && 'has-error has-feedback'}`}>
            {setLabel}
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <RIOSelect
                        id={name}
                        placeholder={placeholder}
                        options={options}
                        value={
                            field.value ? [String(options?.find(i => i.label === field.value)?.label ?? '')] : undefined
                        }
                        useFilter
                        onChange={item => {
                            field.onChange(item?.id);
                        }}
                    />
                )}
            />
            {error && (
                <span className='help-block'>
                    <span>{error.message}</span>
                </span>
            )}
        </div>
    );
};
export default FormFieldSelect;
